// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/remixicon@2.5.0/fonts/remixicon.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Importing Google Fonts and FontAwesome */

/* Other styles here... */

body {
  margin: 0;
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: 'Montserrat', sans-serif;
}
.nav-link{
  cursor: pointer;
}
/* Additional styles... */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAM3C,yBAAyB;;AAEzB;EACE,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,eAAe;AACjB;AACA,yBAAyB","sourcesContent":["/* Importing Google Fonts and FontAwesome */\n@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');\n@import url('https://cdn.jsdelivr.net/npm/remixicon@2.5.0/fonts/remixicon.css');\n\n/* Other styles here... */\n\nbody {\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: 'Montserrat', sans-serif;\n}\n.nav-link{\n  cursor: pointer;\n}\n/* Additional styles... */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
